import React, {Component} from 'react';
import {withRouter} from 'react-router';
import reactMixin from 'react-mixin';
import Entity from './mixins/header';
import {AREA_ID_LIST} from "./configure/configure";
import Ua from './modules/ua';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {areaId: this.props.areaId, showMobileNav: false};
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.areaId) {
            this.updateAreaAction(nextProps.areaId);
        }
    }

    render() {
        const options = AREA_ID_LIST.map(area => {
            return <option key={area.id} value={area.id}>
                {area.name}
            </option>;
        });
        const selectedArea = AREA_ID_LIST.find((area) => {
            return area.id === this.state.areaId;
        });
        const pcHeader = () => {
            return <section className="pc_header">
                <header>
                    <ul>
                        <li>
                            <h1><img src={require('../images/bv.png')} alt="平昌五輪番組表"/></h1>
                        </li>
                        <li className="search_program">
                            <input type="text" placeholder="番組・タレント検索" onKeyDown={e => this.execKeywordSearch(e)}/>
                        </li>
                        <li className="selection_region">
                            <div className="introduction">ご利用の地域</div>
                            <div className="btn-select">
                                <p className="label">{selectedArea ? selectedArea.name : ''}</p>
                                <select className='select' value={this.state.areaId}
                                        onChange={e => this.areaChange(e)}>
                                    {options}
                                </select>
                            </div>
                        </li>
                    </ul>
                    <nav>
                        <ul>
                            <li className="nav_featured_program">
                                <a href="//bangumi.org?from=gorin">
                                    注目番組
                                </a>
                            </li>
                            <li className="nav_tv_schedule">
                                <a href={this.epgUrl()}>
                                    番組表
                                </a>
                            </li>
                            <li className="nav_gorin_schedule">
                                <a href="">
                                    平昌五輪番組表
                                </a>
                            </li>
                        </ul>
                    </nav>
                </header>
            </section>;
        }
        const mobileHeader = () => {
            return <section className="mobile_header">
                <header role="banner">
                    <ul>
                        <li onTouchEnd={e => this.showMobileNav(e)}>
                            <a href="">
                                <img id="menu" src={require('../images/header_menu_icon.png')} alt="Header menu icon"/>
                            </a>
                        </li>
                        <li>
                            <h1>
                                <a href="">
                                    <img src={require('../images/bv.png')} alt="Mobile g guide"
                                         className="logo"/>
                                </a>
                            </h1>
                        </li>
                    </ul>
                </header>
                <nav id="mobile_nav">
                    <ul>
                        <li>
                            <a href="//bangumi.org">
                                <img
                                    src={require('../images/mobile_g_guide.png')}
                                    alt="Mobile g guide" className="logo"/>
                            </a>
                        </li>
                        <li>
                            <a href="//bangumi.org">
                                注目番組
                            </a>
                        </li>
                        <li>
                            <a href={this.epgUrl()}>
                                番組表
                            </a>
                        </li>
                        <li>
                            <a href="/">
                                視聴地域設定:{selectedArea ? selectedArea.name : '東京'}
                            </a>
                        </li>
                        <li>
                            <form action="/search" method="get" onSubmit={e => this.disableSubmit(e)}>
                                <input type="text" name="q" id="search_style" placeholder="番組検索"
                                       onKeyDown={e => this.execKeywordSearch(e)}/>
                            </form>
                        </li>
                    </ul>
                    <div id="sub-menu-closer" className="close" onTouchEnd={e => this.hideMobileNav(e)}><img id="close"
                                                                                                             src={require('../images/close_icon.png')}
                                                                                                             alt="Close icon"/>
                    </div>
                    <section id="sub_menu_back_section" style={{display: this.state.showMobileNav ? 'block' : 'none'}}>
                        <div id="sub_menu_back"></div>
                    </section>
                </nav>

            </section>;
        }
        return Ua.isPcUser(navigator.userAgent) ? pcHeader() : mobileHeader();
    }
}

reactMixin.onClass(Header, Entity);

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/header.js